import { SamplePack } from '@arpeggi/shared'
import { FC } from 'react'
import { Link } from 'react-router-dom'
import { useFormattedDate } from '../hooks'
import { InfoArea } from '../primitives'
import { SPPlaybackButton } from './SPPlaybackButton'

export const SPInfo: FC<{ sp: SamplePack }> = ({ sp }) => {
  const { title, user, createdAt, description } = sp
  const date = useFormattedDate(createdAt)
  return (
    <InfoArea.Root>
      <InfoArea.TitleText css={{ marginRight: '128px' }}>{title}</InfoArea.TitleText>
      <SPPlaybackButton sp={sp} />
      <InfoArea.ArtistSection as={Link} to={`/profile/${user.walletAddress}`}>
        <InfoArea.ArtistAvatar src={user.profilePicture?.url} />
        <InfoArea.ArtistText>{user.displayName}</InfoArea.ArtistText>
        <InfoArea.DateText>{`• ${date}`}</InfoArea.DateText>
      </InfoArea.ArtistSection>
      <InfoArea.Details>{description}</InfoArea.Details>
    </InfoArea.Root>
  )
}
